import(/* webpackMode: "eager" */ "/opt/build/repo/app/settings/page.tsx");
